import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { TableModule } from 'primeng/table';
import * as bootstrap from 'bootstrap';
import { MessageService } from 'primeng/api';
import { user_privilege } from '../../../../_model/user_privilege';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { FormBuilder, FormsModule } from '@angular/forms';

import {
  DatePipe,
  JsonPipe,
  NgClass,
  NgFor,
  NgIf,
  NgStyle,
} from '@angular/common';
import { HighlightDirective } from '../../../_directives/highlight.directive';
import { ActivatedRoute, Router } from '@angular/router';
import { BusyService } from '../../../_services/busy.service';
import { ExportDataService } from '../../../_services/export-data.service';
import { GlobalService } from '../../../_services/global.service';
import { ConstantService } from '../../../_services/constant.service';
import { AuthenticationService } from '../../../_services/authentication.service';
import { DatasearchService } from '../../../_services/datasearch.service';
import { CommanService } from '../../../_services/comman.service';
import { DropdownModule } from 'primeng/dropdown';
import { Location } from '@angular/common';
@Component({
  selector: 'app-mrl',
  standalone: true,
  imports: [
    TableModule,
    CommonModule,
    CalendarModule,
    TooltipModule,
    NgIf,
    NgFor,
    NgClass,
    NgStyle,
    FormsModule,
    HighlightDirective,
    DropdownModule,
  ],
  templateUrl: './mrl.component.html',
  styleUrl: './mrl.component.scss',
})
export class MrlComponent {
  isFullScreen: boolean = false;
  totalRecords: any;
  isListView: boolean = true;
  productDetails: boolean = false;
  cols: any[] = [];
  products_current_datasource: any[] = [];
  rows: number = 50;
  countries: any[] = [];
  cropCommodities: any[] = [];
  selectedCountry: string = 'View All';
  selectedCrop: string = 'View All';
  loading_table = false;
  TableRowsCounts: number[] = [5, 10, 20, 25, 50, 100, 150];
  tablefilter: any = {};
  patentTypes: any[] = [];
  mrlTableFliters!: any;
  rptDataForExcel: any = [];
  dateValue: any = {};
  searchedWords: string[] = [];
  current_GBRN: any = 0;
  filterAppliedWithNoResults = false;
  oldSearchQueryGrid = '';
  searchQueryGrid: string = '';
  serialStart: number = 0;
  privilege_json!: user_privilege;
  is_show_Daily_Download_Exceed_popup: boolean = false;
  is_show_Total_Download_Exceed_popup: boolean = false;
  is_show_Download_Priv_popup: boolean = false;
  matchModeOptions: any = [
    { label: 'Select Filter', value: 'select' },
    { label: 'Date is', value: 'dateIs' },
    { label: 'Date is not', value: 'dateIsNot' },
    { label: 'Date is before', value: 'dateBefore' },
    { label: 'Date is after', value: 'dateAfter' },
  ];
  detailViewTabs = [
    { header: 'BIBLIOGRAPHY', field: '' },
    { header: 'description', field: 'description' },
    { header: 'CLAIMS', field: 'claims' },
    { header: 'PATENT FAMILY', field: 'patent_familf' },
    { header: 'SPC', field: 'spc' },
    { header: 'ORANGE BOOK (OB) PATENTS', field: 'dummy2' },
  ];
  isShowReadMoreDialog: boolean = false;
  readMoreColumn: string = '';
  readMoreContent: string = '';
  detailViewData: any = {};
  updatePrivilege = false;
  oldResult: any = {};
  current_pagenumber: number = 1;
  selectedDetailViewIndex = 0;
  pageLimitInPrivilegeJson: number = 0;
  dynSelectedPatentType: string = '';
  pageLimitInDatabaseLimit: number = 0;
  totalpages: any = 0;
  selectedPage: number = 1;
  searched = true;
  currentFliter: any = {};
  user_data: any;
  first = 0;
  currentSortBy: string = '';
  listSortByfield: string = '';
  listSortOrder: string = 'ASC';
  constructor(
    private messageService: MessageService,
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private globalService: GlobalService,
    private fb: FormBuilder,
    private exportdataService: ExportDataService,
    private datePipe: DatePipe,
    private busyService: BusyService,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private commanService: CommanService,
    private cdr: ChangeDetectorRef,
    private location: Location,

    private _router: Router
  ) {}
  ngOnInit() {
    this.commanService.currentgbrn.subscribe((gbrn_res: any) => {
      if (gbrn_res) {
        this.current_GBRN = gbrn_res;
        this.search_data();
      }
    });
    this.commanService.productInformationData.subscribe((res: any) => {
      const rawQuery = res.searchQueryGrid || '';
      this.searchQueryGrid = this.parseSearchQuery(rawQuery); // <-- returns a string
    });
    this.authentication.getCurrentUserValue().subscribe((val: any) => {
      this.user_data = val;
    });
    this.commanService.getUserPrivilege().subscribe((res: any) => {
      // this.user_data = res;
      this.privilege_json = res || {};
    });

    this.loadColumnDetails();
    // this.getUserPrivilege();
    this.datasearch
      .GetDatabasePageLimit({
        database: 'AgroPat Ultimate Discovery Suite Beta',
      })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.pageLimitInDatabaseLimit = res.data.page_limit
              ? Number(res.data.page_limit)
              : 0;
          } else {
            console.log('Error: API response success is false', res);
          }
        },
        (error: any) => {
          console.log('Error fetching database page limit:', error);
        }
      );
  }
  // async getUserPrivilege(): Promise<void> {
  //   console.log(
  //     '[getUserPrivilege] - Initiating privilege fetch from localStorage.'
  //   );

  //   this.authentication.getCurrentUserValue().subscribe((val: any) => {
  //     console.log('[getUserPrivilege] - Current user data received:', val);

  //     this.user_data = val;

  //     // ✅ Get stored privileges from localStorage
  //     const storedPrivileges = JSON.parse(
  //       localStorage.getItem('user_privilege') || '{}'
  //     );

  //     if (!storedPrivileges || Object.keys(storedPrivileges).length === 0) {
  //       console.warn(
  //         '[getUserPrivilege] - No user_privilege found in localStorage.'
  //       );
  //       return;
  //     }

  //     // ✅ App key for agropat privilege
  //     const appKey = 'agropat-ultimate-discovery-suite-beta';
  //     const privilegeData = storedPrivileges[appKey];

  //     if (!privilegeData) {
  //       console.warn(
  //         `[getUserPrivilege] - No privilege found for app: ${appKey}`
  //       );
  //       return;
  //     }

  //     console.log(
  //       `[getUserPrivilege] - Fetched privilege data for ${appKey}:`,
  //       privilegeData
  //     );

  //     // ✅ Store locally for this component
  //     this.privilege_json = privilegeData;

  //     // ✅ Push privilege data to CommanService (Reactive access)
  //     this.commanService.currentPrivilege.next(this.privilege_json);

  //     console.log(
  //       `[getUserPrivilege] - Privilege JSON pushed to commanService for ${appKey}.`
  //     );
  //   });
  // }

  search_data(isFilterApplied = false) {
    if (isFilterApplied) {
      this.selectedPage = 1;
      this.first = 0;
      this.commanService.currentPrivilege.next(1);
    }

    let postdata = {
      gbrn: this.current_GBRN || '',
      filters:
        Array.isArray(this.mrlTableFliters) && this.mrlTableFliters.length > 0
          ? this.mrlTableFliters
          : [],
      subFilters: {
        country:
          this.selectedCountry !== 'View All' ? this.selectedCountry : '',
        cropCommodity:
          this.selectedCrop !== 'View All' ? this.selectedCrop : '',
      },
      pagenumber: this.current_pagenumber,
      limit: this.rows || 10,
      sortby: '',
    };

    this.busyService.busy();
    this.searched = false;
    this.products_current_datasource = [];

    this.datasearch.getplatformmrldata(postdata).subscribe({
      next: (res: any) => {
        this.products_current_datasource = res?.data.data || [];
        this.totalRecords = res?.data.count || 0;
        this.totalpages = Math.ceil(this.totalRecords / this.rows);

        this.first = (this.selectedPage - 1) * this.rows;

        this.countries = [
          { label: 'All Country', value: 'View All' },
          ...(res.data.countries || []).map((value: string) => ({
            label: value,
            value,
          })),
        ];

        this.cropCommodities = [
          { label: 'All Crop Commodity', value: 'View All' },
          ...(res.data.cropCommodities || []).map((value: string) => ({
            label: value,
            value,
          })),
        ];

        this.filterAppliedWithNoResults =
          Object.keys(this.mrlTableFliters || {}).length > 0 &&
          this.products_current_datasource.length === 0;

        this.searched = true;
        this.loading_table = false;
        this.busyService.idle();
        this.cdr.detectChanges();

        this.products_current_datasource.forEach((row, index) => {
          row.S_NO = (this.current_pagenumber - 1) * this.rows + index + 1;
        });

        this.hideColumns();
      },
      error: (error: any) => {
        console.error('API Error:', error);
        this.products_current_datasource = [];
        this.totalRecords = 0;
        this.totalpages = 0;
        this.filterAppliedWithNoResults = false;

        this.loading_table = false;
        this.busyService.idle();
        this.cdr.detectChanges();
      },
      complete: () => {
        this.searched = true;
        this.loading_table = false;
        this.busyService.idle();
        this.cdr.detectChanges();
      },
    });
  }

  goBackToSearch() {
    this.mrlTableFliters = [];
    this.loadColumnDetails();
    this.search_data();
  }

  scrollLeft() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft -= 500) : '';
  }
  scrollRight() {
    let element = document.querySelector(
      '#tabledata p-table .p-datatable-wrapper'
    );
    element ? (element.scrollLeft += 500) : '';
  }
  filterClass(col: any) {
    if (this.tablefilter && Object.keys(this.tablefilter).length > 0) {
      if (this.tablefilter[col.tableColumnName]) {
        // Ensure the key exists
        if (col.fieldDataType === 'text') {
          if (
            this.tablefilter[col.tableColumnName]?.matchMode === 'contains' &&
            !this.tablefilter[col.tableColumnName]?.value
          ) {
            return '';
          } else {
            return 'filter-stl';
          }
        } else {
          if (
            this.tablefilter[col.tableColumnName]?.[0]?.matchMode ===
              'contains' &&
            !this.tablefilter[col.tableColumnName]?.[0]?.value
          ) {
            return '';
          } else {
            return 'filter-stl';
          }
        }
      }
    }
    return ''; // Default return if undefined
  }

  filterDate(event: any, field: string) {
    this.dateValue[field] = event;
  }
  addDataSpace(data: any) {
    return data != null ? data.toString().replace(/;/gi, '; ') : data;
  }

  patentClass(patentType: any) {
    let patentArr = patentType.split(' ').filter((patent: any) => {
      return patent.toLowerCase() !== 'patent';
    });

    for (let i = 0; i < patentArr.length; i++) {
      for (let j = 0; j < this.patentTypes.length; j++) {
        if (!patentArr[i]) {
          return '';
        } else if (
          this.patentTypes[j].patentType.search(
            new RegExp(patentArr[i], 'i')
          ) >= 0
        ) {
          return this.patentTypes[j].colour_code;
        }
      }
    }
  }

  getPatentNumber(data: any) {
    let regex_patent = /[A-Z]{2}\d{4,10}/gi;
    if (regex_patent.test(data)) {
      return data.match(regex_patent);
    } else {
      return data;
    }
  }
  showReadMore(column: any, content: any) {
    this.isShowReadMoreDialog = true;
    this.readMoreColumn = column;
    this.readMoreContent = content.replace(/;/gi, '; ');
    this.readMoreContent = this.readMoreContent.replace(/\n|\r\n/gm, '<br/>');
    const modalElement = document.getElementById('read_more_modal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.show();
      }
    }
  }

  hideReadMore() {
    const modalElement = document.getElementById('read_more_modal');
    if (modalElement) {
      const modalInstance = new bootstrap.Modal(modalElement);
      if (modalInstance) {
        modalInstance.hide();
      }
    }
  }
  loadProducts(event: any) {
    console.log('🔄 loadProducts() called with event:', event);

    this.updatePrivilege = false;

    this.oldResult = {
      products_current_datasource: this.products_current_datasource,
      totalRecords: this.totalRecords,
      searchQueryGrid: this.oldSearchQueryGrid,
    };
    console.log('📦 oldResult snapshot:', this.oldResult);

    this.loading_table = true;

    // ✅ Capture rows per page dynamically
    this.rows = event.rows;
    console.log('📃 Rows per page set to:', this.rows);

    // ✅ Correctly calculate `pagenumber` for API call
    this.current_pagenumber = Math.floor(event.first / event.rows) + 1;
    console.log('📄 Current Page Number:', this.current_pagenumber);

    // ✅ Ensure user does not exceed page limits
    this.handlePageLimit();
    let maxPagesAllowed =
      this.pageLimitInPrivilegeJson || this.pageLimitInDatabaseLimit;
    console.log('🔐 Max Pages Allowed:', maxPagesAllowed);

    if (maxPagesAllowed && this.current_pagenumber > maxPagesAllowed) {
      console.warn(
        `⚠️ Page limit exceeded! Current: ${this.current_pagenumber}, Max: ${maxPagesAllowed}`
      );
      this.messageService.add({
        severity: 'error',
        detail: `You can only see ${maxPagesAllowed} pages`,
      });
      this.loading_table = false;
      return;
    }

    // ✅ Adjust filters for date values
    if (event.filters) {
      console.log(
        '📅 Filters before processing:',
        JSON.parse(JSON.stringify(event.filters))
      );
      Object.keys(this.dateValue).forEach((dateFilter) => {
        if (event.filters[dateFilter]?.[0]?.matchMode === 'contains') {
          console.log('🗑️ Resetting date filter for:', dateFilter);
          this.dateValue[dateFilter] = null;
        }
        event.filters[dateFilter][0].value = this.dateValue[dateFilter];
      });
      console.log(
        '📅 Filters after processing:',
        JSON.parse(JSON.stringify(event.filters))
      );
    }

    this.tablefilter = event.filters || {}; // ✅ Ensure filters are always defined
    console.log('🧾 Final Applied Filters:', this.tablefilter);

    this.first = event.first; // ✅ Store first record index for pagination
    console.log('🔢 First Record Index:', this.first);

    // ✅ Fix Serial Number Calculation
    this.serialStart = this.first + 1;
    console.log('🔢 Serial Start Number:', this.serialStart);

    // ✅ Handle sorting conditions
    if (event.sortField && this.isListView) {
      this.currentSortBy = `${event.sortField} ${
        event.sortOrder === 1 ? 'ASC' : 'DESC'
      }`;
    } else if (!this.isListView && this.listSortByfield) {
      this.currentSortBy = `${this.listSortByfield} ${this.listSortOrder}`;
    } else {
      this.currentSortBy = '';
    }
    console.log('🔀 Current Sort By:', this.currentSortBy);

    // ✅ Convert filters into Mongo query format
    this.mrlTableFliters = this.convertFiltersToMongoQuery(event.filters);
    console.log('🛠️ MongoDB Filters:', this.mrlTableFliters);

    // ✅ Fetch updated data with correct pagination
    setTimeout(() => {
      console.log(
        '🚀 Triggering search_data() with params => Page:',
        this.current_pagenumber,
        ' | Rows:',
        this.rows
      );
      this.search_data();
    });
  }

  convertFiltersToMongoQuery(filters: any): any[] {
    const mongoFilters: any[] = [];

    Object.keys(filters).forEach((field) => {
      const filterValue = filters[field]?.value;
      const matchMode = filters[field]?.matchMode;

      if (filterValue) {
        let mongoCondition: any;

        switch (matchMode) {
          case 'startsWith':
            mongoCondition = { $regex: `^${filterValue}`, $options: 'i' };
            break;
          case 'contains':
            mongoCondition = { $regex: filterValue, $options: 'i' };
            break;
          case 'notContains':
            mongoCondition = { $not: { $regex: filterValue, $options: 'i' } };
            break;
          case 'endsWith':
            mongoCondition = { $regex: `${filterValue}$`, $options: 'i' };
            break;
          case 'equals':
            mongoCondition = filterValue;
            break;
          case 'notEquals':
            mongoCondition = { $ne: filterValue };
            break;
          default:
            return;
        }

        // If filtering on gbrn_products array
        if (field.startsWith('gbrn_products.')) {
          const subField = field.split('.')[1]; // Extract the nested field
          mongoFilters.push({
            gbrn_products: { $elemMatch: { [subField]: mongoCondition } },
          });
        } else {
          mongoFilters.push({ [field]: mongoCondition });
        }
      }
    });

    return mongoFilters;
  }

  handlePageLimit() {
    this.pageLimitInPrivilegeJson = this.privilege_json.PageLimit
      ? +this.privilege_json.PageLimit
      : 0;
  }
  loadColumnDetails() {
    this.datasearch.MRL_column_config().subscribe(
      (res) => {
        res.data.results.forEach((field: any) => {
          field.columnWidth = parseInt(field.columnWidth.replace('px', ''));
        });
        this.cols = res.data.results;
        console.log('Column details loaded:', this.cols);
      },
      (error) => {
        console.error('Error loading column details:', error);
      }
    );
  }
  applyTableStyles() {
    setTimeout(() => {
      this.cols.forEach((col) => {
        let columnElements = document.querySelectorAll(
          `.col-${col.tableColumnName}`
        );
        columnElements.forEach((el: any) => {
          // Ensure 'px' is appended if col.columnWidth is a number
          el.style.width = col.columnWidth ? `${col.columnWidth}px` : 'auto'; // ✅ Append 'px' if missing
          el.style.backgroundColor = col.columnColor || 'transparent'; // ✅ Apply color dynamically
        });
      });
    }, 500);
  }
  getImageArray(imageData: string | null): string[] {
    return typeof imageData === 'string'
      ? imageData
          .split(';')
          .map((img) => img.trim())
          .filter((img) => img)
      : [];
  }
  getChemicalStructureImages(obj: any, columnName: string): string[] {
    if (obj && obj[columnName] && typeof obj[columnName] === 'string') {
      return obj[columnName]
        .split(';')
        .map((img: string) => img.trim())
        .filter((img: string) => img.length > 0);
    }
    return [];
  }

  resetFilters() {
    this.selectedCountry = 'View All';
    this.selectedCrop = 'View All';
    this.search_data();
  }
  showFullScreen() {
    this.isFullScreen = true;
    const tableElement = this.renderer.selectRootElement('#tabledata', true);
    if (tableElement) {
      this.renderer.addClass(tableElement, 'full-screen-table');
    }
  }
  exitFullScreen() {
    this.isFullScreen = false;
    const tableElement = this.renderer.selectRootElement('#tabledata', true);
    if (tableElement) {
      this.renderer.removeClass(tableElement, 'full-screen-table');
    }
  }

  // Hide columns if columns not have data
  hideColumns() {
    let tempTableData = this.products_current_datasource;
    let tempCols = this.cols;

    this.cols.forEach((currCol) => {
      // For mrl_mongos columns
      if (
        currCol.field !== 'chemicalStructure' &&
        currCol.field !== 'iupac' &&
        currCol.field !== 'casRn' &&
        currCol.field !== 'chemicalClass' &&
        currCol.field !== 'smilesCode' &&
        currCol.field !== 'summaryPhysicochemPropComp' &&
        currCol.field !== 'summaryPhysicochemPropExperi' &&
        currCol.field !== 'indication'
      ) {
        let isAllFieldHaveData = tempTableData.every(
          (row) => !row[currCol.field]
        );

        // If all field not have data then hide it
        if (isAllFieldHaveData) {
          tempCols.forEach((col) => {
            if (col.field === currCol.field) {
              col.isDisplay = 0;
            }
          });
        }
      }
      // For basic_product_details_MONGO
      else {
        let hideColumn = false;
        tempTableData.forEach((row) => {
          let ads_data = row.gbrn_products;

          if (ads_data.length) {
            let isAllFieldHaveData_ads = ads_data.every(
              (obj: any) => !obj[currCol.field]
            );
            if (isAllFieldHaveData_ads) {
              hideColumn = true;
            } else {
              hideColumn = false;
            }
          } else {
            hideColumn = true;
          }
        });

        if (hideColumn) {
          tempCols.forEach((col) => {
            if (col.field === currCol.field) {
              col.isDisplay = 0;
            }
          });
        }
      }
    });

    this.cols = tempCols;
  }
  checkUserDownloadPrivillege(): boolean {
    //Check User Have Access to Search
    if (!this.privilege_json.Download) {
      this.is_show_Download_Priv_popup = true;
      this.messageService.add({
        severity: 'error',
        summary: 'Access Denied',
        detail: 'You do not have privilege to download data from this database.',
      });
      return false;
    }
    //Check Daily Search Exceed
    const todayDownloadCount =
      Number(this.privilege_json.today_download_count) || 0;
    const dailyDownloadLimit =
      Number(this.privilege_json.DailyDownloadLimit) || 0;
    if (todayDownloadCount >= dailyDownloadLimit) {
      this.is_show_Daily_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your daily download limit.',
      });
      return false;
    }
    //Check Total Search Exceed
    const downloadCount = Number(this.privilege_json.DownloadCount) || 0;
    if (downloadCount <= 0) {
      this.is_show_Total_Download_Exceed_popup = true;
      this.messageService.add({
        severity: 'warn',
        summary: 'Limit Reached',
        detail: 'You have reached your total available download limit.',
      });
      return false;
    }
    this.privilege_json.DownloadCount = downloadCount - 1;
    this.privilege_json.today_download_count = todayDownloadCount + 1;

    // Save updated counts to localStorage
    const today = new Date().toDateString();
    const userData = {
      date: today,
      today_search_count: this.privilege_json.today_search_count,
      today_download_count: this.privilege_json.today_download_count,
    };
    localStorage.setItem(
      `user_${this.user_data.userid}_daily_counts`,
      JSON.stringify(userData)
    );

    return true;
  }
  exportExcel(extension: any) {
    if (!this.checkUserDownloadPrivillege()) {
      console.log('Export denied: User does not have download privileges.');
      return;
    }

    console.log('Export initiated with extension:', extension);

    let postdata = {
      gbrn: this.current_GBRN || '',
      filters:
        Array.isArray(this.mrlTableFliters) && this.mrlTableFliters.length > 0
          ? this.mrlTableFliters
          : [],
      subFilters: {
        country:
          this.selectedCountry !== 'View All' ? this.selectedCountry : '',
        crop_commodity:
          this.selectedCrop !== 'View All' ? this.selectedCrop : '',
      },
      pagenumber: 1,
      limit: 1000,
    };

    // console.log('Export postdata:', postdata);

    this.busyService.busy();
    this.datasearch.getplatformmrldata(postdata).subscribe(
      (response: any) => {
        const DownloadData = response.data.data || [];
        // console.log('Export data received:', DownloadData);

        this.rptDataForExcel = [];

        const displayedColumns = this.cols
          .filter((col) => col.isDisplay === 1)
          .sort((a, b) => a.displayOrder - b.displayOrder);

        const headers = displayedColumns.map((col) => col.header);
        const fields = displayedColumns.map((col) => col.field);

        console.log('header --------', headers);
        console.log('fields --------', fields);
        console.log('downloaddata------------', DownloadData);

        // Process rows
        DownloadData.forEach((row: any, index: number) => {
          row.S_NO = index + 1;

          const rowData = fields.map((field) => {
            let productValues: any[] = [];

            // Fetch all gbrn_products values
            if (row.gbrn_products?.length > 0) {
              productValues = row.gbrn_products
                .map((p: any) => p[field])
                .filter((v:any) => v !== '' && v !== null && v !== undefined);
            }

            // Join multiple values
            if (productValues.length > 0) {
              return productValues.join('\n');
            }

            // Fallback to row value
            return row[field];
          });

          this.rptDataForExcel.push(rowData);
        });

        // FILTER COLUMNS WITH NO DATA
        const validCols = [];
        const validHeaders = [];

        for (let i = 0; i < fields.length; i++) {
          const field = fields[i];

          const hasData = this.rptDataForExcel.some((rowArr: any) => {
            const value = rowArr[i];
            return (
              value !== null &&
              value !== undefined &&
              value !== '' &&
              value !== ' '
            );
          });

          if (hasData) {
            validCols.push(fields[i]);
            validHeaders.push(headers[i]);
          }
        }

        const fieldsFiltered = validCols;
        const headersFiltered = validHeaders;

        // BUILD CLEAN DATA
        const filteredData = this.rptDataForExcel.map((row: any) =>
          fieldsFiltered.map((f) => row[fields.indexOf(f)])
        );

        // FINAL EXPORT OBJECT
        let reportData = {
          title: 'MRL Data Report',
          data: filteredData,
          headers: headersFiltered,
          sheetname: 'data',
          file_extention: extension,
          searchterm: this.searchQueryGrid,
        };

        this.exportdataService.exportExcel(reportData);

        // console.log('Processed data for export:', this.rptDataForExcel);
      },
      (error: any) => {
        console.error('Export Error:', error);
      },
      () => {
        this.busyService.idle();
        // console.log('Export process completed.');
      }
    );
  }
  parseSearchQuery(query: string): string {
    const regex = /ACTIVE\s*INGREDIENT:\s*\(([^)]+)\)/gi;
    let matches: string[] = [];
    let match;

    while ((match = regex.exec(query)) !== null) {
      matches.push(match[1].toUpperCase()); // Convert each to uppercase
    }

    // Replace original condition logic (AND/OR/etc.) in the query
    let result = query;

    // Replace with placeholders to capture order
    let placeholderIndex = 0;
    result = result.replace(regex, () => `{{${placeholderIndex++}}}`);

    // Replace placeholders with capitalized matches
    matches.forEach((val, i) => {
      result = result.replace(`{{${i}}}`, val);
    });

    return result;
  }
}
